import React from 'react';
import styles from './AgencyReportsHeader.module.scss';
import { AgencyReportsHeaderFilter } from './AgencyReportsHeaderFilter/AgencyReportsHeaderFilter';
import { ReportPreFilter } from '../../../../Models';

export interface AgencyReportsHeaderProps {
  hasCadIntegration: boolean;
  filterSelected: ReportPreFilter | undefined;
  isLoading?: boolean;
  onFilterChange: (selected: ReportPreFilter) => void;
}

export const AgencyReportsHeader = ({
  hasCadIntegration,
  filterSelected,
  isLoading = false,
  onFilterChange
}: AgencyReportsHeaderProps): React.ReactElement<AgencyReportsHeaderProps> => {
  return (
    <div className={styles.agencyReportsHeader}>
      <h2
        className={styles.title}
      >{`${hasCadIntegration ? 'CAD/RMS + Contacts' : 'Contacts'}`}</h2>
      {hasCadIntegration && (
        <AgencyReportsHeaderFilter
          selected={filterSelected}
          onFilterChange={onFilterChange}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};
